import type * as React from 'react'

// NOTE (Phase 00 contract gap, still open): reference/ICON-NORMALISATION.md §(c) specifies a
// shared `SvgIconProps` from './types.ts'. That file has no owning task in any phase file yet
// (flagged in PHASE-00's Notes as an open gap). This component must not create `./types.ts`
// unprompted, so the prop type is inlined here rather than imported. Once `./types.ts` exists,
// this local type should be replaced with an import from it to match every other icon component.
type SvgIconProps = Omit<React.SVGProps<SVGSVGElement>, 'children'> & {
  /** Accessible name. Omit for a purely decorative icon (default: aria-hidden). */
  title?: string
}

export function IconHouse16({ title, ...rest }: SvgIconProps) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.24902C8.16427 1.24902 8.32677 1.2828 8.47852 1.3457C8.63019 1.4086 8.76872 1.50004 8.88477 1.61621L13.8838 6.61621C13.9707 6.70322 14.0448 6.80308 14.1025 6.91113L14.1553 7.02246L14.1963 7.1377C14.2317 7.25483 14.25 7.37718 14.25 7.5V13.5C14.2497 13.914 13.9141 14.25 13.5 14.25H9.5C9.08595 14.25 8.75026 13.914 8.75 13.5V10.25H7.25V13.5C7.24974 13.914 6.91405 14.25 6.5 14.25H2.5C2.08595 14.25 1.75026 13.914 1.75 13.5V7.5C1.75 7.33631 1.78225 7.17376 1.84473 7.02246L1.89746 6.91113C1.95517 6.80308 2.02934 6.70322 2.11621 6.61621L7.11523 1.61719C7.23128 1.50101 7.36981 1.40861 7.52148 1.3457L7.63672 1.30371C7.75426 1.26802 7.87671 1.24902 8 1.24902ZM3.25 7.60352V12.75H5.75V9.5C5.75021 9.08597 6.08592 8.75 6.5 8.75H9.5C9.91408 8.75 10.2498 9.08597 10.25 9.5V12.75H12.75V7.60352L8 2.85352L3.25 7.60352Z"
        fill="currentColor"
      />
    </svg>
  )
}
